<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_alpari') }}
        game-preview-settings(v-for="({ num, numbers, operations }, index) in parameters.examples" :key="index")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                span(slot="value") {{ num }}
            game-preview-setting(v-if="numbers.length !== 0")
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numbers') }}
                span(slot="value") {{ numbers.join(', ') }}
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}
                span(slot="value") {{ getOperationName(operations) }}
</template>

<script>
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        mixins: [GamePreviewMixin],
        props: ['parameters', 'exerciseId', 'type'],
        methods: {
            getOperationName(operations) {
                if (operations.multiply) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_operationMultiply');
                }
                return this.$i18n.t('trainer.trainer_gameFormSetting_operationDivide');
            },
        },
    };
</script>
